export default "https://d1e6s5z4lzmgxx.cloudfront.net/1e48d3d4-9cd4-48c4-b169-1af184d58c4c/images/rushing-icon.svg?a6fc9c460d0598538acdfd6a3f03db1f";